import React, { useRef } from "react";
import "./GalleryLightboxLocal.scss";

import FsLightbox from "fslightbox-react";
import { Portal } from "react-overlays";
import { overlaysRef } from "src/App";

export function GalleryLightboxLocal({ sources, show, hide }) {
  const lightboxRef = useRef(null);

  return (
    <Portal container={overlaysRef}>
      <FsLightbox
        // toggler={show}
        openOnMount
        types={sources.map((gallerySource) => gallerySource.type)}
        sources={sources.map((gallerySource) => gallerySource.url)}
        key={sources}
        // key is remountComponent toggler so in future i suggest using gallerySuccess.length
        ref={lightboxRef}
        onClose={hide}
      />
    </Portal>
  );
}
